import React from 'react';
import { Anchor, FlexCol, FlexRow, Text, theme } from '@veeqo/ui';
import { useTranslation } from 'context/TranslationContext';

export const MessageEl = ({
  preTextId,
  postTextId,
  linkTextId,
  href,
  jobId,
}: {
  preTextId?: string;
  postTextId?: string;
  linkTextId?: string;
  href?: string;
  jobId?: string;
}) => {
  const { t } = useTranslation();
  return (
    <FlexCol gap="none">
      {!!preTextId && (
        <Text variant="body">
          {t(preTextId)}

          {!!href && (
            <Anchor
              href={`mailto:${href}`}
              rel="noopener noreferrer"
              style={{ color: theme.colors.secondary.blue.base }}
            >
              {`${(linkTextId && t(linkTextId)) || href} `}
            </Anchor>
          )}
        </Text>
      )}
      {!!postTextId && <Text variant="body">{t(postTextId)}</Text>}

      {!!jobId && (
        <FlexRow style={{ marginTop: theme.sizes.md }}>
          <Text variant="bodySmallBold">{t('veeqo-issue-id')}</Text>
          <Text variant="bodySmall">{`${jobId}`}</Text>
        </FlexRow>
      )}
    </FlexCol>
  );
};
